/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

import { Heading, Paragraph } from "../UI/Typoraphy";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4rem 0;
`;

const InfoCard = ({ heading, icon, desc, align = "center" }) => {
  return (
    <Card
      css={{
        justifyItems:
          align === "left"
            ? "flex-start"
            : align === "right"
            ? "flex-end"
            : "center",
      }}
    >
      <img
        src={icon}
        alt={`${heading} icon`}
        css={{ marginBottom: "2.5rem", height: "7rem" }}
      />
      <Heading
        level={3}
        style={{ marginBottom: "2rem", color: "#50976A", textAlign: align }}
      >
        {heading}
      </Heading>
      <Paragraph
        style={{ color: "#50976A", textAlign: align, maxWidth: "41rem" }}
      >
        {desc}
      </Paragraph>
    </Card>
  );
};

export default InfoCard;
